var React = require('react');

function LinkedInInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"none","fillRule":"evenodd","key":0},React.createElement("circle",{"cx":"15","cy":"15","r":"14.5"})),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.836 21.4417h-2.9842v-4.3152c0-1.1295-.4668-1.9005-1.4933-1.9005-.7852 0-1.2219.5203-1.4251 1.0218-.0762.18-.0643.4307-.0643.6814v4.5125h-2.9564s.0381-7.6439 0-8.3387h2.9564v1.3087c.1747-.5722 1.1194-1.3889 2.627-1.3889 1.8704 0 3.3399 1.1995 3.3399 3.7823v4.6366zM9.92286 12.06h-.01905c-.95266 0-1.57031-.6375-1.57031-1.4455 0-.82373.6359-1.44781 1.60762-1.44781.97098 0 1.56798.62252 1.58698 1.44541 0 .8081-.616 1.4479-1.60524 1.4479zm-1.24879 1.043h2.63173v8.3387H8.67407V13.103z","stroke":"none","key":1})]);
}

LinkedInInline.defaultProps = {"width":"30","height":"30","stroke":"#97979D","fill":"#97979D"};

module.exports = LinkedInInline;

LinkedInInline.default = LinkedInInline;
